
if (!customElements.get('announcement-bar-slider')) {
  customElements.define('announcement-bar-slider', class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const slider = this.querySelector('.swiper');
      if (!slider) return;

      const autoplay = this.dataset.autoplay === 'true';
      const delay = parseInt(this.dataset.delay) || 5000;

      const initSwiper = () => {
        if (typeof Swiper === 'undefined') {
          setTimeout(initSwiper, 100);
          return;
        }

        this.swiper = new Swiper(slider, {
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: this.querySelector('.announcement-bar__button--next'),
            prevEl: this.querySelector('.announcement-bar__button--prev'),
          },
          autoplay: autoplay ? {
            delay: delay,
            disableOnInteraction: false,
          } : false,
          on: {
            init: function() {
              setTimeout(() => {
                this.update();
              }, 100);
            }
          }
        });
        
        // Final fallback update
        setTimeout(() => {
          this.swiper.update();
        }, 500);
      };

      initSwiper();
    }
  });
}

const handleAnnouncementClose = () => {
  const closeBtn = document.querySelector('.announcement-bar__close-button');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      const parentSection = closeBtn.closest('.section-announcement');
      if (parentSection) {
        parentSection.style.display = 'none';
        document.body.classList.add('announcement-hide');
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', handleAnnouncementClose);
document.addEventListener('shopify:section:load', handleAnnouncementClose);